import "core-js/modules/es.function.name.js";
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "custom-component resource-box"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["id", "src"];
var _hoisted_4 = ["id", "onClick"];
var _hoisted_5 = {
  class: "file-img"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "file-name"
};
import { onMounted } from 'vue';
import { fileClass, imgCoverMap } from '@/utils/index';
export default {
  __name: 'eResource',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    },
    isMenu: {
      type: Boolean,
      default: false
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    onMounted(function () {
      emit('loaded', 'eResource');
    });
    return function (_ctx, _cache) {
      var _component_video_player = _resolveComponent("video-player");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.elementContent.resource && __props.elementContent.resource.type === 'image' ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.elementContent.content,
        style: {
          "width": "100%"
        },
        class: _normalizeClass([!__props.edit && 'preview-image']),
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.handleClickImage && _ctx.handleClickImage.apply(_ctx, arguments);
        })
      }, null, 10, _hoisted_2)) : __props.elementContent.resource && __props.elementContent.resource.type === 'video' ? (_openBlock(), _createElementBlock("video", {
        key: 1,
        id: !__props.isMenu && 'resource-' + __props.element.id,
        src: __props.elementContent.content,
        controls: "",
        class: "video-box",
        controlsList: "nodownload"
      }, null, 8, _hoisted_3)) : __props.elementContent.resource && __props.elementContent.resource.type === 'audio' ? (_openBlock(), _createBlock(_component_video_player, {
        key: 2,
        src: __props.elementContent.content,
        controls: "",
        "control-bar": {
          fullscreenToggle: false
        },
        type: "video/mp3",
        style: {
          "height": "30px"
        },
        class: "video-box video-box-audio",
        onPlay: _ctx.onPlay
      }, {
        default: _withCtx(function (_ref2) {
          var player = _ref2.player;
          return [_createElementVNode("div", {
            id: !__props.isMenu && 'resource-' + __props.element.id,
            style: {
              "display": "none"
            },
            onClick: function onClick($event) {
              return player.pause();
            }
          }, "暂停", 8, _hoisted_4)];
        }),
        _: 1
      }, 8, ["src", "onPlay"])) : __props.elementContent.resource ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "file-item-container",
        onDblclick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.preview(__props.elementContent.content, 'edit');
        }),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.preview(__props.elementContent.content, 'preview');
        })
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        class: "file-img-content",
        src: __props.elementContent.resource.type && _unref(imgCoverMap)[_unref(fileClass)(__props.elementContent.resource.type)],
        alt: ""
      }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(__props.elementContent.resource.name || '未命名'), 1)], 32)) : _createCommentVNode("", true)]);
    };
  }
};